import { Skeleton } from '@shared/components/ui/shadcn';

export const TenantChildSelectorSkeleton = () => {
  return (
    <div className="border border-card-border rounded-lg p-4 mb-6 shadow-sm">
      <div>
        <Skeleton className="h-6 w-44 rounded-full mb-2 bg-hover-press" />
        <Skeleton className="h-4 w-64 rounded-full bg-hover-press" />
      </div>

      <div className="mt-4">
        <Skeleton className="h-10 w-full bg-hover-press" />
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 rounded-lg border border-card-border bg-card-bg px-4 py-4">
          <Skeleton className="w-4 h-4 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-72 rounded-full bg-hover-press" />
        </div>
      </div>
    </div>
  );
};
